import loadable from '@loadable/component';
import type { Locale } from './locales';

/* istanbul ignore file */

function getMessagesCompiled(locale: Locale) {
  /* eslint-disable import/no-unresolved */

  switch (locale) {
    case 'ar-SA':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/ar" */ '../../lang/ar-SA.json'));
    case 'de-DE':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/de" */ '../../lang/de-DE.json'));
    case 'en':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/en" */ '../../lang/en.json'));
    case 'en-XA':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/zh-TW" */ '../../lang/qps-ploc.json'));
    case 'es-ES':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/es" */ '../../lang/es-ES.json'));
    case 'fr-FR':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/fr" */ '../../lang/fr-FR.json'));
    case 'he-IL':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/he" */ '../../lang/he-IL.json'));
    case 'hi-IN':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/hi" */ '../../lang/hi-IN.json'));
    case 'it-IT':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/it" */ '../../lang/it-IT.json'));
    case 'ja-JP':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/ja" */ '../../lang/ja-JP.json'));
    case 'ko-KR':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/ko" */ '../../lang/ko-KR.json'));
    case 'nb-NO':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/nb" */ '../../lang/nb-NO.json'));
    case 'nl-NL':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/nl" */ '../../lang/nl-NL.json'));
    case 'pt-BR':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/pt-BR" */ '../../lang/pt-BR.json'));
    case 'ro-RO':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/ro" */ '../../lang/ro-RO.json'));
    case 'ru-RU':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/ru" */ '../../lang/ru-RU.json'));
    case 'sv-SE':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/sv" */ '../../lang/sv-SE.json'));
    case 'xx-HA':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/sv" */ '../../lang/qps-plocm.json'));
    case 'zh-CN':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/zh-CN" */ '../../lang/zh-CN.json'));
    case 'zh-TW':
      // @ts-ignore file missing until production build started
      return loadable.lib(() => import(/* webpackChunkName: "lang/zh-TW" */ '../../lang/zh-TW.json'));
  }
  /* eslint-enable import/no-unresolved */
}

function getMessagesUncompiled(locale: Locale) {
  switch (locale) {
    case 'ar-SA':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/ar" */ '../../../messages/default.ar-SA.json'));
    case 'de-DE':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/de" */ '../../../messages/default.de-DE.json'));
    case 'en':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/en" */ '../../../messages/default.json'));
    case 'en-XA':
      return loadable.lib(
        () => import(/* webpackChunkName: "lang-dev/zh-TW" */ '../../../messages/default.qps-ploc.json')
      );
    case 'es-ES':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/es" */ '../../../messages/default.es-ES.json'));
    case 'fr-FR':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/fr" */ '../../../messages/default.fr-FR.json'));
    case 'he-IL':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/he" */ '../../../messages/default.he-IL.json'));
    case 'hi-IN':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/hi" */ '../../../messages/default.hi-IN.json'));
    case 'it-IT':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/it" */ '../../../messages/default.it-IT.json'));
    case 'ja-JP':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/ja" */ '../../../messages/default.ja-JP.json'));
    case 'ko-KR':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/ko" */ '../../../messages/default.ko-KR.json'));
    case 'nb-NO':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/nb" */ '../../../messages/default.nb-NO.json'));
    case 'nl-NL':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/nl" */ '../../../messages/default.nl-NL.json'));
    case 'pt-BR':
      return loadable.lib(
        () => import(/* webpackChunkName: "lang-dev/pt-BR" */ '../../../messages/default.pt-BR.json')
      );
    case 'ro-RO':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/ro" */ '../../../messages/default.ro-RO.json'));
    case 'ru-RU':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/ru" */ '../../../messages/default.ru-RU.json'));
    case 'sv-SE':
      return loadable.lib(() => import(/* webpackChunkName: "lang-dev/sv" */ '../../../messages/default.sv-SE.json'));
    case 'xx-HA':
      return loadable.lib(
        () => import(/* webpackChunkName: "lang-dev/sv" */ '../../../messages/default.qps-plocm.json')
      );
    case 'zh-CN':
      return loadable.lib(
        () => import(/* webpackChunkName: "lang-dev/zh-CN" */ '../../../messages/default.zh-CN.json')
      );
    case 'zh-TW':
      return loadable.lib(
        () => import(/* webpackChunkName: "lang-dev/zh-TW" */ '../../../messages/default.zh-TW.json')
      );
  }
}

export function getMessages(locale: Locale) {
  return process.env.NODE_ENV === 'production' ? getMessagesCompiled(locale) : getMessagesUncompiled(locale);
}
